'use client'

import { ForwardedRef, forwardRef } from 'react'
import { tss } from 'tss-react/mui'
import Flag from '../Flag/Flag'
import { TIocCode } from '../Flag/types'

const useStyles = tss.create(({ theme }) => ({
    flagStackOuter: {
        display: 'flex',
        marginTop: theme.spacing(-2),
        marginLeft: theme.spacing(1.5),

        '&:hover': {
            textDecoration: 'none',
        },
    },
    flagStackInner: {
        position: 'relative',
        backgroundColor: theme.palette.background.paper,
        padding: theme.spacing(0.5),
        borderRadius: '10%',
        marginRight: theme.spacing(-7),
    },
}))

type FlagStackProps = {
    flag: TIocCode
}

const FlagStack = forwardRef(function FlagStackRef({ flag }: FlagStackProps, ref?: ForwardedRef<HTMLDivElement>) {
    const { classes } = useStyles()

    return (
        <div ref={ref} className={classes.flagStackOuter}>
            <div className={classes.flagStackInner}>
                <Flag code={flag} size="large" />
            </div>
        </div>
    )
})

export default FlagStack
